(function () {
  document.querySelectorAll('[data-nn-product]').forEach(initProduct);

  function initProduct(root) {
    const dataAttr = root.getAttribute('data-variants');
    let variants = [];
    try {
      variants = JSON.parse(dataAttr || '[]');
    } catch (_) {
      variants = [];
    }
    const moneyFormat = root.getAttribute('data-nn-money-format') || '';

    initGallery(root);
    initVariantSelector(root, variants, moneyFormat);
    initQuantity(root);
    initAddToCart(root);
  }

  function setGallery(root, idx) {
    const slides = root.querySelectorAll('[data-nn-gallery-slide]');
    const thumbs = root.querySelectorAll('[data-nn-gallery-thumb]');
    let found = false;
    slides.forEach((s) => {
      const on = Number(s.getAttribute('data-nn-gallery-slide')) === idx;
      if (on) found = true;
      s.classList.toggle('is-active', on);
    });
    if (!found) return;
    thumbs.forEach((t) =>
      t.classList.toggle('is-active', Number(t.getAttribute('data-nn-gallery-thumb')) === idx)
    );
  }

  function initGallery(root) {
    const thumbs = root.querySelectorAll('[data-nn-gallery-thumb]');
    if (!thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setGallery(root, Number(thumb.getAttribute('data-nn-gallery-thumb')));
      });
    });
  }

  function initVariantSelector(root, variants, moneyFormat) {
    const selector = root.querySelector('[data-nn-variant-selector]');
    if (!selector) return;
    const inputs = Array.from(selector.querySelectorAll('[data-nn-option-input]'));
    const variantIdField = root.querySelector('[data-nn-variant-id]');
    const priceEl = root.querySelector('[data-nn-price]');
    const submit = root.querySelector('[data-nn-add-button]');
    const submitLabel = root.querySelector('[data-nn-add-label]');

    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        selector.querySelectorAll('.nn-product__option-value').forEach((label) => {
          const i = label.querySelector('[data-nn-option-input]');
          label.classList.toggle('is-selected', !!(i && i.checked));
        });

        const selected = [];
        selector.querySelectorAll('[data-option-index]').forEach((fs) => {
          const checked = fs.querySelector('[data-nn-option-input]:checked');
          if (checked) selected.push(checked.value);
        });

        const match = variants.find((v) => {
          return (
            (v.option1 || null) === (selected[0] || null) &&
            (v.option2 || null) === (selected[1] || null) &&
            (v.option3 || null) === (selected[2] || null)
          );
        });

        if (!match) return;

        if (variantIdField) variantIdField.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price, moneyFormat);
        if (submit) submit.disabled = !match.available;
        if (submitLabel) submitLabel.textContent = match.available ? 'Add to Bag' : 'Sold out';

        // Switch the gallery to the variant's own image, if one is assigned.
        const media = match.featured_media;
        if (media && typeof media.position === 'number') {
          setGallery(root, media.position - 1);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      });
    });
  }

  function initQuantity(root) {
    const input = root.querySelector('[data-nn-qty]');
    if (!input) return;
    root.querySelectorAll('[data-nn-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = Number(btn.getAttribute('data-nn-qty-step')) || 1;
        const max = Number(input.getAttribute('max')) || 99;
        const min = Number(input.getAttribute('min')) || 1;
        const next = Math.min(max, Math.max(min, (Number(input.value) || 1) + step));
        input.value = next;
      });
    });
  }

  function initAddToCart(root) {
    const form = root.querySelector('[data-nn-product-form]');
    if (!form) return;
    const btn = form.querySelector('[data-nn-add-button]');
    const label = form.querySelector('[data-nn-add-label]');
    let prevLabel;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variantId = form.querySelector('[data-nn-variant-id]').value;
      const qty = Number(form.querySelector('[data-nn-qty]').value) || 1;

      if (btn) btn.disabled = true;
      prevLabel = label ? label.textContent : '';
      if (label) label.textContent = 'Adding…';

      try {
        await window.NettyNature.cart.addItem(variantId, qty);
        if (label) label.textContent = 'Added';
        setTimeout(() => {
          if (label) label.textContent = prevLabel;
          if (btn) btn.disabled = false;
        }, 1400);
      } catch (err) {
        if (label) label.textContent = 'Could not add';
        setTimeout(() => {
          if (label) label.textContent = prevLabel;
          if (btn) btn.disabled = false;
        }, 1600);
      }
    });
  }

  function formatMoney(cents, format) {
    const amount = (Number(cents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    if (!format) return amount;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(cents) / 100).toString());
  }
})();
